module.exports = __webpack_public_path__ + "static/media/bike-image-01-01.80f374c3.png";